import styled from 'styled-components'

export const List = styled.div`
  img {
    border-radius: 0 !important;
  }
`
